/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontSocial_user$ref = any;
export type StorefrontHead_user$ref = any;
export type StorefrontHead_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": StorefrontSocial_user$ref;
    readonly " $refType": StorefrontHead_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontHead_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "StorefrontSocial_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'be37b972407a12aa7fb1298dc9b08296';
export default node;
